export default {
  "login_screen-reader-page-title": "%clientName% Member Portal",
  "login_page-title": "Member Sign-in",
  "___login_action_submit": "",
  "___login_action_register": "",
  "login_text_error-message": "Username or password incorrect.",
  "___login_form-label_username": "",
  "login_form-label_password": "Enter Your Password",
  "login_form-hint_password": "At least 8 characters",
  "login_subheadline": "Having a health savings account (HSA) with SelectAccount means making the most of your healthcare dollars.",
  "___login_form-error_username_required": "",
  "___login_form-error_password_required": "",
  "login_home-url": "https://www.hellofurther.com",
  "login_home-vermont-url": "https://learn-mymoneybcbsvt.hellofurther.com",
  "login_contact-url": "https://www.hellofurther.com/contact",
  "login_contact-vermont-url": "https://learn-mymoneybcbsvt.hellofurther.com/Brokers_and_Agents/BCBS_Vermont_Materials/Contact_Blue_Cross_and_Blue_Shield_of_Vermont",
  'login-signin-box-mfa': 'Email MFA Code',
  'login-signin-box-mfa-warning': 'An MFA code has been sent to your email. Please enter the code to complete sign-in.',
  'login-signin-box-remember-device': 'Remember Device (personal only)',
  'login-signin-box-code-mismatch-error': 'The MFA code entered is incorrect. Please try again.',
  'login-signin-box-code-expired-error': 'The MFA code has expired. Please request a new code.',
  'login-mfa-error-required': 'MFA code is required',
  'login-mfa-error-invalid': 'MFA code must be numeric',
  'login-mfa-error-invalid-length': 'MFA code must be 6 digits',

  // FORGOT USERNAME
  "forgot-username_page-title": "Forgot Username?",
  "forgot-username_page-subtitle": "We can help you fix that.",
  "forgot-username_page-description": "Okay. We're going to ask you for a few things, and then we'll send you your username to your email on file.",
  "forgot-username_form-label_first-name": "First Name",
  "forgot-username_form-label_last-name": "Last Name",
  "forgot-username_form-label_dob": "Date of Birth",
  "forgot-username_form-label_select-account-id": "SA ID",
  "___forgot-username_form-error_first-name_required": "",
  "___forgot-username_form-error_last-name_required": "",
  "___forgot-username_form-error_dob_required": "",
  "___forgot-username_form-error_dob_date": "",
  "___forgot-username_form-error_dob_invalid-dob": "",
  "___forgot-username_form-error_select-account-id_required": "",
  "___forgot-username_action_submit": "",
  "___forgot-username_action_done": "",
  "forgot-username_text_loading-message": "Finding your information…",
  "___forgot-username_title_confirm-close": "",
  "___forgot-username_text_confirm-close": "",
  "___forgot-username_action_confirm-close_cancel": "",
  "___forgot-username_action_confirm-close_confirm": "",

  // FORGOT PASSWORD
  "forgot-password_page-title": "Forgot Password?",
  "forgot-password_page-subtitle": "We can help you with that.",
  "forgot-password_page-description": "Okay. We're going to ask you for your username. That will send you an email to change your password.",
  "forgot-password_step-2_page-title": "Yup. It's password time.",
  "forgot-password_step-2_page-description": "Okay, we emailed you a temporary pin. Next we'll need you to pick out a new password. After this, you'll be able to login.",
  "___forgot-password_title_confirm-close": "",
  "___forgot-password_text_confirm-close": "",
  "___forgot-password_action_confirm-close_cancel": "",
  "___forgot-password_action_confirm-close_confirm": "",
  "___forgot-password_form-label_token": "",
  "___forgot-password_form-label_username": "",
  "___forgot-password_form-label_password": "",
  "___forgot-password_form-label_confirm-password": "",
  "___forgot-password_action_done": "",
  "___forgot-password_action_continue": "",
  "___forgot-password_action_submit": "",
  "forgot-password_action_signin": "Go to Sign In",

  // LOGGED OUT
  "logged-out_headline_success": "You have successfully signed out.",
  "logged-out_sub-headline_success": "Thanks for staying secure!",
  "timed-out_headline_warning": "Session Timed Out",
  "timed-out_sub-headline_warning": "Your session has expired.",
  "logged-out_action_login": "Sign In Again",

  // PUBLIC FOOTER LINKS
  "footer-public-link-nondiscrimination": "non-discrimination/",
  "footer-public-link-legal-terms": "legal-terms-of-use/",
  "footer-public-link-privacy": "privacy-policy/",
  "footer-public-link-security": "security-policy/",
  "footer-public-link-contact": "contact/",
  "footer-public-link-vermont-contact": "https://learn-mymoneybcbsvt.hellofurther.com/Brokers_and_Agents/BCBS_Vermont_Materials/Contact_Blue_Cross_and_Blue_Shield_of_Vermont",

  // Get SA ID
  "get-sa-id-title": "What's My SA ID?",
  "get-sa-id-sub-title": "For security purposes, please enter the first five digits of your zip code.",
  "get-sa-id-zip-label": "Zip Code",
  "get-sa-id-zip-error-required": "Zip code is required",
  "get-sa-id-zip-error-numeric": "The zip code can only contain numbers.",
  "get-sa-id-zip-error-length": "The zip code must be 5 digits in length.",
  "get-sa-id-loading-message": "Getting SA ID",
  "get-sa-id-success-button-register": "Register",
  "get-sa-id-success-button-done": "I'm Done",
};